const isLoginHintVisible = ref(false)
const redirectUrl = ref<string | null>(null)

export default function useLoginHint() {
  const { $tracker } = useNuxtApp()

  const setRedirectUrl = (path: string | null) => {
    redirectUrl.value = path
  }

  const openLoginHint = () => {
    isLoginHintVisible.value = true
    $tracker('show_login_hint')
  }

  const closeLoginHint = () => {
    isLoginHintVisible.value = false
    if (redirectUrl.value)
      setRedirectUrl(null)
  }

  return {
    isLoginHintVisible,
    redirectUrl,
    setRedirectUrl,
    openLoginHint,
    closeLoginHint,
  }
}
